module.exports = __webpack_public_path__ + "img/Popup1.f233147d.png";